// apps/admin/src/hooks/use-composer-history.ts
//
// P5 UI Polish W2 T6 — Zundo-wrapped Zustand store for the composer
// layout-editor's zones array (spec §3.2).
//
// zundo's temporal middleware tracks state mutations with a 50-entry
// ring buffer. Access undo/redo via `useComposerHistory.temporal.getState()`.

import { create } from 'zustand';
import { temporal } from 'zundo';
import type { Zone } from '@displaycms/contracts';

interface ComposerHistoryState {
  zones: Zone[];
  setZones: (zones: Zone[]) => void;
  patchZone: (id: string, patch: Partial<Zone>) => void;
}

export const useComposerHistory = create<ComposerHistoryState>()(
  temporal(
    (set) => ({
      zones: [],
      setZones: (zones) => set({ zones }),
      patchZone: (id, patch) =>
        set((s) => ({
          zones: s.zones.map((z) => (z.id === id ? { ...z, ...patch } : z)),
        })),
    }),
    { limit: 50 },
  ),
);
